/* AP · Tarot popup — Halloween Private Sale free card.
 * Markup: snippets/ap-tarot-popup.liquid (rendered only by templates/collection.halloween-private-sale.json).
 * Identity: Postscript appends `s-id=<subscriber id>` to every SMS link click. Read from the URL, kept in
 *   localStorage (ap_tarot_sid) for later visits. No s-id -> "your card is waiting in your texts" state.
 * API: POST /apps/afp-analytics/tarot/free  (x-www-form-urlencoded: sid, card 0|1|2)
 *   -> { ok:true, card, title, headline, body?, code?, expires?, cta:{label,url}, points?, repeat }
 *   -> { ok:false, error:"closed"|"busy"|"bad_sid"|..., message }
 *   points = { mine, rank|null, cutoff|null, topN, leaderboardUrl } (owner 04/10: topN 5 on Sunday, 20 on Saturday).
 * Owner 04/10: from Sunday 00:00 store time the free card is The Moon = a free silk scarf (no size: one variant with
 *   size null in the picker JSON -> tapping a design claims it). Leggings already won on Saturday stay leggings.
 * Test before the backend is live: ?tarot_mock=star | moon | wheel | wheel_buyer (imply an s-id) | nosid
 *   (also: closed | fail)
 */
(function () {
  'use strict';

  // ===== CARD ART: CDN URLs (one edit). '' = CSS-drawn placeholder card. =====
  // 600x900 art, no text: the card name is rendered in HTML inside the dark band at the bottom of each face.
  var ART = {
    BACK: 'https://cdn.shopify.com/s/files/1/0976/0597/6345/files/tarot-card-back.png?v=1790937619&width=600',
    star: 'https://cdn.shopify.com/s/files/1/0976/0597/6345/files/tarot-face-star.png?v=1790937627&width=600',
    wheel: 'https://cdn.shopify.com/s/files/1/0976/0597/6345/files/tarot-face-wheel.png?v=1790937635&width=600',
    moon: 'https://cdn.shopify.com/s/files/1/0976/0597/6345/files/tarot-face-moon.png?v=1790937643&width=600',
    lovers: 'https://cdn.shopify.com/s/files/1/0976/0597/6345/files/tarot-face-lovers.png?v=1790937650&width=600',
    sun: 'https://cdn.shopify.com/s/files/1/0976/0597/6345/files/tarot-face-sun.png?v=1790937656&width=600'
  };
  // ==========================================================================================

  var NAMES = { star: 'The Star', wheel: 'Wheel of Fortune', moon: 'The Moon', lovers: 'The Lovers', sun: 'The Sun' };
  var GLYPHS = { star: '✦', wheel: '☸︎', moon: '☾︎', lovers: '♡︎', sun: '☀︎' };
  var HICCUP = 'Something hiccupped. Tap again.';
  var ERRORS = {
    closed: 'The deck opens Saturday at 9 AM.',
    busy: 'Lots of cards turning right now. Tap again in a moment.'
  };
  // Server says it does not know this subscriber -> forget it and show the "text COSTUME" state.
  var SID_ERRORS = { bad_sid: 1, no_sid: 1, unknown_sid: 1 };
  var SID_KEY = 'ap_tarot_sid';
  var SID_RE = /^[A-Za-z0-9_-]{1,64}$/;

  var root = document.getElementById('atp');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var params = new URLSearchParams(location.search);
  var MOCK = params.get('tarot_mock') || '';
  // Owner 04/10 ("today every person gets 1 free tarot card again"): one free card per store day, so the stored
  // card is per day too. Saturday 2026-10-03 keeps the bare key (its card stays in storage, untouched); later days
  // add _YYYY-MM-DD, so a new day opens on a fresh deck instead of yesterday's card. Store day = PDT (UTC-7) all sale.
  var DAY = new Date(Date.now() - 7 * 3600000).toISOString().slice(0, 10);
  var STORE_KEY = 'afp_tarot_free_v1' + (DAY > '2026-10-03' ? '_' + DAY : '') + (MOCK ? '_mock' : '');
  var ENDPOINT = root.getAttribute('data-endpoint') || '/apps/afp-analytics/tarot/free';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Owner 03/10: the wait felt long -- shorter turn and hold (was 850 + 900 ms).
  var FLIP_MS = reduced ? 300 : 600;
  var HOLD_MS = reduced ? 250 : 350;

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var dialog = $('.atp__dialog');
  var pickStage = $('[data-atp-pick]');
  var noStage = $('[data-atp-nolink]');
  var resStage = $('[data-atp-res]');
  var errEl = $('[data-atp-err]');
  var fan = $('[data-atp-fan]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('.atp-card'));
  var pill = document.querySelector('[data-atp-pill]');
  var docEl = document.documentElement;
  var isOpen = false, everOpened = false, busy = false, lastFocus = null, closeTimer = null;

  // ---------- storage (both can throw in private mode) ----------
  function sGet(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function sSet(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }
  function sDel(store, k) { try { window[store].removeItem(k); } catch (e) {} }
  // Demo links: ?tarot_mock=star&tarot_reset=1 forgets the stored card on every load, so each test turns a fresh card.
  if (params.get('tarot_reset')) sDel('localStorage', STORE_KEY);
  function loadResult() {
    try { var r = JSON.parse(sGet('localStorage', STORE_KEY) || 'null'); return r && r.ok ? r : null; } catch (e) { return null; }
  }
  // Owner 04/10: the card turned on 2026-10-03 stays under the bare key and its prize stays claimable, so the start
  // stage links back to it (unpicked leggings, or the code). Read only: the bare key is never written or removed.
  var LEGACY = null;
  if (DAY > '2026-10-03' && !MOCK) {
    try { var lg = JSON.parse(sGet('localStorage', 'afp_tarot_free_v1') || 'null'); if (lg && lg.ok) LEGACY = lg; } catch (e) {}
  }

  // ---------- identity: Postscript s-id ----------
  function readSid() {
    if (MOCK === 'nosid') return '';
    var fromUrl = (params.get('s-id') || '').trim();
    if (SID_RE.test(fromUrl)) { if (!MOCK) sSet('localStorage', SID_KEY, fromUrl); return fromUrl; }
    var stored = sGet('localStorage', SID_KEY) || '';
    if (SID_RE.test(stored)) return stored;
    return MOCK ? 'mock-sid' : ''; // star | wheel | wheel_buyer | closed | fail imply an s-id
  }
  var SID = readSid();

  // ---------- art ----------
  function paintArt(artEl, glyphEl, key) {
    var url = ART[key];
    artEl.parentNode.classList.toggle('has-art', !!url);
    if (url) {
      artEl.style.backgroundImage = 'url("' + url + '")';
      artEl.classList.add('has-art');
      glyphEl.textContent = '';
    } else {
      artEl.style.backgroundImage = '';
      artEl.classList.remove('has-art');
      glyphEl.textContent = GLYPHS[key] || '✦';
    }
  }
  if (ART.BACK) {
    Array.prototype.forEach.call(root.querySelectorAll('.atp-card__back'), function (b) {
      b.style.backgroundImage = 'url("' + ART.BACK + '")';
      b.classList.add('has-art');
    });
  }

  var preloaded = false;
  function preloadFaces() {
    if (preloaded) return;
    preloaded = true;
    ['star', 'wheel', 'moon', 'lovers', 'sun'].forEach(function (k) { if (ART[k]) (new Image()).src = ART[k]; });
  }

  var hintEl = $('.atp__hint');
  function setErr(msg) {
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
    hintEl.classList.toggle('is-off', !!msg);
  }

  // ---------- network ----------
  function mockResponse() {
    if (MOCK === 'fail') return Promise.reject(new Error('mock fail'));
    var res;
    var points = MOCK === 'wheel_buyer'
      ? { mine: 142, rank: 41, cutoff: 186, leaderboardUrl: '/pages/leaderboard' }
      : { mine: 0, rank: null, cutoff: 186, topN: MOCK === 'moon' ? 5 : 20, leaderboardUrl: '/pages/leaderboard' };
    if (MOCK === 'closed') res = { ok: false, error: 'closed', message: 'The deck opens Saturday at 9 AM.' };
    else if (MOCK === 'wheel' || MOCK === 'wheel_buyer') res = {
      ok: true, card: 'wheel', title: 'Wheel of Fortune', headline: '$5 off your order this weekend',
      code: 'TAROT-DEMO12', expires: 'Sun Oct 4, 11:59 PM',
      cta: { label: 'Apply & shop', url: '/discount/TAROT-DEMO12?redirect=/collections/halloween-private-sale' },
      points: points, repeat: false
    };
    else if (MOCK === 'moon') res = {
      ok: true, card: 'moon', title: 'The Moon', headline: 'A free silk scarf.',
      body: 'Pick the design. The silk scarf is free, you only pay $9.99 shipping.',
      cta: { label: 'Choose my scarf', url: '#' },
      points: points, repeat: false
    };
    else res = {
      ok: true, card: 'star', title: 'The Star', headline: 'Free leggings — on us.',
      body: 'Pick your print and size next. It’s $0, shipping included.',
      cta: { label: 'Choose my leggings', url: '#' },
      points: points, repeat: false
    };
    return new Promise(function (resolve) { setTimeout(function () { resolve(res); }, 700); });
  }

  function post(card) {
    if (MOCK) return mockResponse();
    // No s-id (email, shared link, other browser): the email typed above the cards is the key (owner 03/10).
    var body = (SID ? 'sid=' + encodeURIComponent(SID) : 'email=' + encodeURIComponent(typedEmail())) + '&card=' + encodeURIComponent(card);
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    return fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json' },
      body: body,
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (timer) clearTimeout(timer);
      return r.json(); // non-JSON (proxy error page) rejects -> hiccup
    }, function (e) { if (timer) clearTimeout(timer); throw e; });
  }

  // ---------- result ----------
  function safeUrl(u) {
    if (!u || typeof u !== 'string') return '';
    if (u === '#' || (/^\/(?!\/)/.test(u))) return u;
    try { var x = new URL(u, location.href); if (x.origin === location.origin) return x.href; } catch (e) {}
    return '';
  }

  // Leaderboard points: every $1 spent today = 1 point. Owner 04/10: the winner count is the API's topN
  // (Sunday = The Midnight 5, owner 04/10: was 10), so the block's name, ladder and "#N is at" follow it.
  var POINTS_COPY = {
    5: ['The Midnight 5', 'Every $1 you spend today = 1 point. At midnight the top 5 win: #1 $200 cash back + two Halloween sets + a silk scarf \u00b7 #2 and #3 two Halloween sets + a silk scarf \u00b7 #4 and #5 a Halloween set + a silk scarf.'],
    20: ['The Midnight 20', 'Every $1 you spend today = 1 point. At midnight the top 20 win: a free Halloween set (dress + leggings) for #4\u201320, a set plus a silk scarf for #2\u20133, and $100 cash back + a set + a scarf for #1.']
  };
  var topN = 0; // last topN the API gave (0 = not known yet)
  function fillPoints(p) {
    var box = $('[data-atp-points]');
    if (!p || typeof p !== 'object') { box.hidden = true; return; }
    // Owner 04/10: a card stored before Sunday's API (no topN) carries Saturday's points/rank/#20 cutoff: show the ladder only.
    if (!Number(p.topN)) { $('[data-atp-points-mine]').textContent = ''; var c0 = $('[data-atp-points-cut]'); c0.textContent = ''; c0.hidden = true; $('[data-atp-points-link]').href = '/pages/leaderboard'; box.hidden = false; return; }
    var fmt = function (n) { return Number(n).toLocaleString('en-US'); };
    var mine = Math.max(0, Math.floor(Number(p.mine) || 0));
    var rank = Number(p.rank);
    $('[data-atp-points-mine]').textContent = mine > 0
      ? 'Your points: ' + fmt(mine) + (rank > 0 ? ' · You’re #' + fmt(rank) : '')
      : 'Your points: 0';
    var n = Number(p.topN);
    var kEl = $('[data-atp-points-k]'), tEl = $('[data-atp-points-t]'); // absent until the new snippet is pushed
    if (POINTS_COPY[n]) { topN = n; if (kEl) kEl.textContent = POINTS_COPY[n][0]; if (tEl) tEl.textContent = POINTS_COPY[n][1]; }
    var cut = Number(p.cutoff);
    var cutEl = $('[data-atp-points-cut]');
    cutEl.textContent = cut > 0 ? '#' + (topN || (kEl && / 5$/.test(kEl.textContent) ? 5 : 20)) + ' is at ' + fmt(cut) + ' points right now.' : '';
    cutEl.hidden = !(cut > 0);
    $('[data-atp-points-link]').href = '/pages/leaderboard'; // the sale page turns this into the on-page sheet
    box.hidden = false;
  }

  function fillResult(res) {
    var key = res.card;
    paintArt($('[data-atp-res-art]'), $('[data-atp-res-glyph]'), key);
    var name = res.title || NAMES[key] || '';
    var resName = $('[data-atp-res-name]');
    resName.textContent = name;
    resName.classList.toggle('is-long', name.length > 12);
    $('[data-atp-res-title]').textContent = name;
    $('[data-atp-res-head]').textContent = res.headline || '';
    var bodyEl = $('[data-atp-res-body]');
    bodyEl.textContent = res.body || '';
    bodyEl.hidden = !res.body;
    $('[data-atp-res-repeat]').hidden = !res.repeat;
    var codeBox = $('[data-atp-res-codebox]');
    $('[data-atp-res-code]').textContent = res.code || '';
    codeBox.hidden = !res.code;
    $('[data-atp-copy]').textContent = 'Copy';
    var exp = $('[data-atp-res-exp]');
    exp.textContent = res.expires ? 'Expires ' + res.expires : '';
    exp.hidden = !res.expires;
    var cta = $('[data-atp-res-cta]');
    var url = res.cta && safeUrl(res.cta.url);
    // Free leggings: claim right here instead of leaving the sale page (owner 03/10). Owner 04/10: the Sunday scarf (moon) too.
    claimKind = key === 'moon' ? 'scarf' : 'leggings';
    var inPlace = (key === 'star' || key === 'moon') && url && (/\/pick$/.test(url) || (MOCK && url === '#'));
    cta.hidden = !url || inPlace;
    if (url && !inPlace) { cta.href = url; cta.textContent = res.cta.label || 'Continue'; }
    resStage.classList.remove('is-claiming', 'is-claimed');
    if (inPlace) startClaim(url); else claimBox.hidden = true;
    fillPoints(res.points);
  }

  // ---------- in-popup claim (free leggings) ----------
  var claimBox = $('[data-atp-claim]');
  var MOCK_CLAIM = { ok: true, done: false, slot: 'leggings', noun: 'leggings', askEmail: false, products: [{design:"Fuvu",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/fuvu-halloween-leggings-front.webp?v=1789730052",variants:[{id:"1",size:"S"},{id:"2",size:"M"},{id:"3",size:"L"},{id:"4",size:"XL"},{id:"5",size:"2XL"},{id:"6",size:"3XL"}]},{design:"Njozi",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/njozi-leggings-front.webp?v=1789730133",variants:[{id:"1",size:"S"},{id:"2",size:"M"},{id:"3",size:"L"},{id:"4",size:"XL"},{id:"5",size:"2XL"},{id:"6",size:"3XL"}]},{design:"Popo",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/popo-halloween-leggings-front.webp?v=1789730150",variants:[{id:"1",size:"S"},{id:"2",size:"M"},{id:"3",size:"L"},{id:"4",size:"XL"},{id:"5",size:"2XL"},{id:"6",size:"3XL"}]},{design:"Upinde",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/image-01_b38a2619-78f2-43bd-9a50-f234ea4dd7fa.webp?v=1786612703",variants:[{id:"1",size:"S"},{id:"2",size:"M"},{id:"3",size:"L"},{id:"4",size:"XL"},{id:"5",size:"2XL"},{id:"6",size:"3XL"}]},{design:"Pwani",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/image-01_5cca846c-25e2-4df6-9b94-dc7ce3e81054.webp?v=1786603315",variants:[{id:"1",size:"S"},{id:"2",size:"M"},{id:"3",size:"L"},{id:"4",size:"XL"},{id:"5",size:"2XL"},{id:"6",size:"3XL"}]},{design:"Afrocentric",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/image-01_3dc7bfb8-c783-4f9a-aec5-ee481c7d8b19.webp?v=1786601572",variants:[{id:"1",size:"S"},{id:"2",size:"M"},{id:"3",size:"L"},{id:"4",size:"XL"},{id:"5",size:"2XL"},{id:"6",size:"3XL"}]},{design:"Samaki",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/image-01_67d52c99-d3ea-41db-adc9-e562e3b7092f.webp?v=1786603367",variants:[{id:"1",size:"S"},{id:"2",size:"M"},{id:"3",size:"L"},{id:"4",size:"XL"},{id:"5",size:"2XL"},{id:"6",size:"3XL"}]},{design:"Asili",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/image-01_0f83dc3d-310a-4a2e-beed-5baf1c4b5388.webp?v=1786601660",variants:[{id:"1",size:"S"},{id:"2",size:"M"},{id:"3",size:"L"},{id:"4",size:"XL"},{id:"5",size:"2XL"},{id:"6",size:"3XL"}]}] };
  var MOCK_SCARF = { ok: true, done: false, slot: 'scarf', noun: 'silk scarf', askEmail: true, products: [{design:"Rangi",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/front_d4af5252-e435-47f5-b7e3-794298dcc131.jpg?v=1784624238",variants:[{id:"1",size:null}]},{design:"Upinde",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/front_edec6592-20fa-4dee-82c0-7e49b16d11bb.jpg?v=1784624454",variants:[{id:"2",size:null}]},{design:"Mwanga",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/front_e0cf41aa-c549-4e4a-95dd-d9221e0800b8.jpg?v=1784624319",variants:[{id:"3",size:null}]},{design:"Asili",image:"https://cdn.shopify.com/s/files/1/0976/0597/6345/files/front_add9b858-a5a3-4998-886a-adcd767408ab.jpg?v=1784624405",variants:[{id:"4",size:null}]}] };
  // What the free card claims here: 'leggings' (The Star) or 'scarf' (The Moon, owner 04/10). Set from the card, then the picker's slot.
  var claimKind = 'leggings';
  function claimUrl(url) { return url + (url.indexOf('?') < 0 ? '?' : '&') + 'format=json'; }
  function claimFetch(url, body) {
    if (MOCK) return new Promise(function (r) { setTimeout(function () { r(body ? { ok: true, done: true, lines: [MOCK === 'moon' ? 'Rangi Silk Scarf' : 'Fuvu Halloween Leggings · Size L'], emailedTo: 'y***@email.com' } : (MOCK === 'moon' ? MOCK_SCARF : MOCK_CLAIM)); }, 500); });
    return fetch(claimUrl(url), body ? {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    } : { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function keepShopping() {
    close();
    var g = document.querySelector('.ap-ctabs') || document.querySelector('.product-grid') || document.querySelector('main');
    if (g) g.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  }
  // Owner 03/10 ~21:50 VN: "giao diện bé quá. Chia bước ra" -- step 1 the print (big 2-column grid), step 2 the size,
  // then a screen of its own that confirms the claim and sends them back to the sale.
  function toTop() { dialog.scrollTop = 0; }
  function renderDone(j) {
    resStage.classList.remove('is-claiming'); resStage.classList.add('is-claimed');
    claimBox.textContent = '';
    var box = el('div', 'xpk-done');
    box.appendChild(el('p', 'xpk-done__ok', '✓'));
    var sc = claimKind === 'scarf'; // owner 04/10: the Sunday free card is a silk scarf
    box.appendChild(el('p', 'xpk-done__h', j.failed ? (sc ? 'Got it. Your silk scarf is reserved.' : 'Got it. Your leggings are reserved.')
      : (sc ? 'Your free silk scarf is on the way!' : 'Your free leggings are on the way!')));
    box.appendChild(el('p', 'xpk-done__what', (j.lines || []).join(', ') || (sc ? 'Free silk scarf' : 'Free leggings')));
    box.appendChild(el('p', null, j.failed ? (sc ? 'Our team is adding it by hand and will email you within a day.' : 'Our team is adding them by hand and will email you within a day.')
      : (j.emailedTo ? 'Check ' + j.emailedTo + (sc ? ': we sent you the link to claim it. You pay $9.99 shipping there.' : ': we sent you the link to claim them.') : 'Your confirmation is on its way by email.')));
    claimBox.appendChild(box);
    // Owner 03/10: the confirmation also says what keeps the game going, right above the way back to the sale.
    var more = el('div', 'xpk-more');
    [['✦', 'Every order over $50', ' gets a chance to open another card.'],
     (topN || (root.getAttribute('data-sun') ? 5 : 20)) === 5 ? ['☾', 'The top 5 spenders', ' win at midnight: #1 $200 cash back + two Halloween sets + a silk scarf \u00b7 #2 and #3 two Halloween sets + a silk scarf \u00b7 #4 and #5 a Halloween set + a silk scarf.'] // owner 04/10: The Midnight 5
       : ['☾', 'The top 20 spenders', ' each win a free Halloween set every night at midnight.']].forEach(function (r) {
      var row = el('div', 'xpk-more__row'); row.appendChild(el('span', 'xpk-more__ic', r[0]));
      var p = el('p'); p.appendChild(el('b', null, r[1])); p.appendChild(document.createTextNode(r[2]));
      row.appendChild(p); more.appendChild(row);
    });
    claimBox.appendChild(more);
    var k = el('button', 'xpk-keep', 'Continue to shop'); k.type = 'button'; k.addEventListener('click', keepShopping);
    claimBox.appendChild(k);
    toTop();
  }
  function renderPicker(url, j) {
    var prods = (j.products || []).filter(function (p) { return p && p.variants && p.variants.length; });
    claimBox.textContent = '';
    if (!prods.length) { claimBox.appendChild(el('p', 'xpk__err', HICCUP)); return; }
    resStage.classList.add('is-claiming');
    // Owner 04/10: a scarf has no size (one variant, size null) -- one step, tapping a design claims it.
    var single = function (p) { return p.variants.length === 1 && p.variants[0].size == null; };
    var isScarf = j.slot === 'scarf' || prods.every(single);
    if (isScarf) claimKind = 'scarf'; else if (j.slot) claimKind = 'leggings';
    var sel = { p: -1, v: null, email: '' };
    var img = function (p, w) { return p.image ? p.image + (p.image.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : ''; };

    function showPrints() {
      if (isScarf) { showScarves(); return; }
      claimBox.textContent = '';
      claimBox.appendChild(el('p', 'xpk__step', 'Step 1 of 2'));
      claimBox.appendChild(el('p', 'xpk__h', 'Pick your print'));
      var grid = el('div', 'xpk__grid'); claimBox.appendChild(grid);
      prods.forEach(function (p, i) {
        var b = el('button', 'xpk__it' + (i === sel.p ? ' on' : '')); b.type = 'button'; b.setAttribute('aria-label', p.design || 'Print ' + (i + 1));
        var im = el('img'); im.src = img(p, 360); im.alt = ''; im.loading = 'lazy';
        b.appendChild(im); b.appendChild(el('span', null, p.design || ''));
        b.addEventListener('click', function () { if (sel.p !== i) sel.v = null; sel.p = i; showSizes(); });
        grid.appendChild(b);
      });
      toTop();
    }

    // The silk scarf (owner 04/10): one step, no size. A tap only selects the design; the button under the
    // grid sends the claim (same pattern as the leggings), and the $9.99 shipping note sits above the grid.
    function showScarves() {
      claimBox.textContent = '';
      claimBox.appendChild(el('p', 'xpk__h', 'Pick your silk scarf'));
      claimBox.appendChild(el('p', 'xpk__note', 'The silk scarf is free. We email you a checkout to add your address and pay $9.99 shipping.')).style.margin = '-6px 0 12px';
      var grid = el('div', 'xpk__grid xpk__grid--sq'); claimBox.appendChild(grid);
      var go = el('button', 'xpk__go', 'Send my free silk scarf'); go.type = 'button';
      var err = el('p', 'xpk__err'); err.hidden = true;
      prods.forEach(function (p, i) {
        var b = el('button', 'xpk__it' + (i === sel.p ? ' on' : '')); b.type = 'button'; b.setAttribute('aria-label', p.design || 'Design ' + (i + 1));
        b.setAttribute('aria-pressed', i === sel.p ? 'true' : 'false');
        var im = el('img'); im.src = img(p, 360); im.alt = ''; im.loading = 'lazy';
        b.appendChild(im); b.appendChild(el('span', null, p.design || ''));
        b.addEventListener('click', function () {
          sel.p = i; err.hidden = true;
          Array.prototype.forEach.call(grid.children, function (c) { c.classList.toggle('on', c === b); c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
          go.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
        });
        grid.appendChild(b);
      });
      var email = null;
      if (j.askEmail) {
        claimBox.appendChild(el('p', 'xpk__h', 'Your email')).style.marginTop = '14px';
        email = el('input', 'xpk__email'); email.type = 'email'; email.autocomplete = 'email'; email.placeholder = 'you@email.com'; email.setAttribute('aria-label', 'Your email');
        email.value = sel.email;
        claimBox.appendChild(email);
      }
      claimBox.appendChild(go);
      claimBox.appendChild(err);
      var fail = function (msg) {
        go.disabled = false; go.textContent = 'Send my free silk scarf';
        err.textContent = msg; err.hidden = false;
        err.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
      };
      go.addEventListener('click', function () {
        var p = prods[sel.p];
        if (!p) { fail('Pick a design first.'); return; }
        var body = { variant_id: p.variants[0].id };
        if (email) {
          var v = (email.value || '').trim(); sel.email = v;
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { fail('Add the email where we should send your checkout.'); email.focus(); return; }
          body.email = v;
        }
        err.hidden = true; go.disabled = true; go.textContent = 'Sending\u2026';
        claimFetch(url, body).then(function (r) {
          if (r && r.ok && r.done) { renderDone(r); return; }
          if (r && r.ok && !r.done) { renderPicker(url, r); return; }
          fail((r && r.message) || HICCUP);
        }).catch(function () { fail(HICCUP); });
      });
      toTop();
    }

    function showSizes() {
      var p = prods[sel.p];
      claimBox.textContent = '';
      claimBox.appendChild(el('p', 'xpk__step', 'Step 2 of 2'));
      claimBox.appendChild(el('p', 'xpk__h', 'Pick your size'));
      var pick = el('div', 'xpk__pick');
      var im = el('img'); im.src = img(p, 480); im.alt = p.design || '';
      pick.appendChild(im);
      var meta = el('div', 'xpk__pick-meta');
      meta.appendChild(el('p', 'xpk__pick-name', (p.design || '') + ' leggings'));
      var back = el('button', 'xpk__back', '← Change print'); back.type = 'button';
      back.addEventListener('click', showPrints);
      meta.appendChild(back);
      pick.appendChild(meta);
      claimBox.appendChild(pick);
      var sizes = el('div', 'xpk__sz'); claimBox.appendChild(sizes);
      p.variants.forEach(function (v) {
        var b = el('button', v.id === sel.v ? 'on' : '', v.size || 'One size'); b.type = 'button';
        b.setAttribute('aria-pressed', v.id === sel.v ? 'true' : 'false');
        b.addEventListener('click', function () {
          sel.v = v.id;
          Array.prototype.forEach.call(sizes.children, function (c) { c.classList.toggle('on', c === b); c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
          err.hidden = true;
        });
        sizes.appendChild(b);
      });
      var email = null;
      if (j.askEmail) {
        claimBox.appendChild(el('p', 'xpk__h', 'Your email')).style.marginTop = '14px';
        email = el('input', 'xpk__email'); email.type = 'email'; email.autocomplete = 'email'; email.placeholder = 'you@email.com'; email.setAttribute('aria-label', 'Your email');
        email.value = sel.email;
        claimBox.appendChild(email);
      }
      var go = el('button', 'xpk__go', 'Send my free leggings'); go.type = 'button'; claimBox.appendChild(go);
      var err = el('p', 'xpk__err'); err.hidden = true; claimBox.appendChild(err);
      claimBox.appendChild(el('p', 'xpk__note', 'The leggings are free. We email you a checkout to add your address and pay $9.99 shipping.'));
      go.addEventListener('click', function () {
        if (!sel.v) { err.textContent = 'Pick your size first.'; err.hidden = false; return; }
        var body = { variant_id: sel.v };
        if (email) {
          var v = (email.value || '').trim(); sel.email = v;
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { err.textContent = 'Add the email where we should send your $0 checkout.'; err.hidden = false; return; }
          body.email = v;
        }
        err.hidden = true; go.disabled = true; go.textContent = 'Sending…';
        claimFetch(url, body).then(function (r) {
          if (r && r.ok && r.done) { renderDone(r); return; }
          if (r && r.ok && !r.done) { renderPicker(url, r); return; }
          go.disabled = false; go.textContent = 'Send my free leggings';
          err.textContent = (r && r.message) || HICCUP; err.hidden = false;
        }).catch(function () { go.disabled = false; go.textContent = 'Send my free leggings'; err.textContent = HICCUP; err.hidden = false; });
      });
      toTop();
    }

    showPrints();
  }
  function startClaim(url) {
    claimBox.hidden = false;
    claimBox.textContent = '';
    claimBox.appendChild(el('p', 'xpk__note', 'Loading the prints…'));
    claimFetch(url).then(function (j) {
      if (j && j.ok && j.done) renderDone(j);
      else if (j && j.ok) renderPicker(url, j);
      else { claimBox.textContent = ''; claimBox.appendChild(el('p', 'xpk__err', HICCUP)); }
    }).catch(function () { claimBox.textContent = ''; claimBox.appendChild(el('p', 'xpk__err', HICCUP)); });
  }

  // one stage visible at a time; the dialog is labelled by the visible stage's heading
  function showStage(stage, labelId) {
    [pickStage, noStage, resStage].forEach(function (s) { s.hidden = s !== stage; });
    dialog.setAttribute('aria-labelledby', labelId);
    dialog.scrollTop = 0;
  }

  function showResult(res, animate) {
    fillResult(res);
    showStage(resStage, 'atp-title-res');
    resStage.classList.toggle('is-in', !!animate);
  }

  var emailBox = $('[data-atp-email]'), emailIn = $('[data-atp-email-in]');
  function typedEmail() { return ((emailIn && emailIn.value) || '').trim(); }
  function showStart() {
    showStage(pickStage, 'atp-title');
    if (emailBox) emailBox.hidden = !!SID;
    showLegacy();
  }

  // One small line above the fine print; leggings only while the pick is still open (the picker JSON says so).
  var legacyChecked = false;
  function showLegacy() {
    if (!LEGACY || legacyChecked) return;
    legacyChecked = true;
    var url = LEGACY.cta && safeUrl(LEGACY.cta.url);
    if (!url || url === '#') return;
    var add = function (text) {
      var p = el('p', 'atp__fine'), a = el('a', null, text);
      a.href = url;
      p.appendChild(a);
      pickStage.insertBefore(p, $('.atp__fine', pickStage));
    };
    if (LEGACY.card === 'star' && /\/pick$/.test(url)) {
      claimFetch(url).then(function (j) { if (j && j.ok && !j.done) add('Your free leggings are still waiting. Choose them'); }).catch(function () {});
    } else if (LEGACY.card === 'wheel' && LEGACY.code) {
      add('Your code ' + LEGACY.code + ' is still yours. Apply it');
    }
  }

  function reveal(btn, res) {
    paintArt($('.atp-card__art', btn), $('[data-atp-glyph]', btn), res.card);
    var nm = $('[data-atp-name]', btn);
    nm.textContent = res.title || NAMES[res.card] || '';
    nm.classList.toggle('is-long', nm.textContent.length > 12);
    btn.classList.remove('is-pending');
    // slide the chosen card to the middle of the fan
    var fr = fan.getBoundingClientRect(), br = btn.getBoundingClientRect();
    btn.style.setProperty('--atp-dx', Math.round((fr.left + fr.width / 2) - (br.left + br.width / 2)) + 'px');
    btn.classList.add('is-chosen');
    fan.classList.add('is-revealing');
    // next frame so the chosen card lifts before it turns
    requestAnimationFrame(function () { requestAnimationFrame(function () { btn.classList.add('is-flipped'); }); });
    setTimeout(function () { showResult(res, true); busy = false; root.classList.remove('is-busy'); }, FLIP_MS + HOLD_MS);
  }

  function pick(btn) {
    if (busy) return;
    if (!SID && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(typedEmail())) {
      showStart(); setErr('Add your email first. That is where your gift goes.');
      if (emailIn) emailIn.focus();
      return;
    }
    busy = true;
    setErr('');
    root.classList.add('is-busy');
    btn.classList.add('is-pending');
    var done = function (msg) {
      busy = false;
      root.classList.remove('is-busy');
      btn.classList.remove('is-pending');
      setErr(msg);
    };
    post(btn.getAttribute('data-card')).then(function (res) {
      if (!res || res.ok !== true || !res.card) {
        var code = res && res.error;
        if (SID_ERRORS[code]) { done('Add your email to turn your card.'); SID = ''; sDel('localStorage', SID_KEY); showStart(); return; }
        done((res && res.message) || ERRORS[code] || HICCUP);
        return;
      }
      sSet('localStorage', STORE_KEY, JSON.stringify(res));
      reveal(btn, res);
    }).catch(function () { done(HICCUP); });
  }

  cards.forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });

  // ---------- open / close ----------
  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    everOpened = true;
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    if (SID) preloadFaces();
    var stored = loadResult();
    if (!busy) { if (stored) showResult(stored, false); else showStart(); }
    root.hidden = false;
    docEl.classList.add('atp-lock');
    if (pill) pill.hidden = true;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    dialog.focus({ preventScroll: true });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    docEl.classList.remove('atp-lock');
    closeTimer = setTimeout(function () { root.hidden = true; }, reduced ? 0 : 220);
    if (pill) pill.hidden = false;
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-atp-close]')) close();
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-atp-open]');
    if (t) { e.preventDefault(); open(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  $('[data-atp-shop]').addEventListener('click', function () {
    close();
    var g = document.querySelector('.ap-ctabs') || document.querySelector('.product-grid') || document.querySelector('main');
    if (g) g.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });

  $('[data-atp-copy]').addEventListener('click', function () {
    var btn = this, code = $('[data-atp-res-code]').textContent;
    var ok = function () { btn.textContent = 'Copied'; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, function () {});
    else {
      var r = document.createRange(); r.selectNodeContents($('[data-atp-res-code]'));
      var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      try { if (document.execCommand('copy')) ok(); } catch (e) {}
    }
  });

  // ---------- boot: opt-in only (owner 03/10) ----------
  // No auto-open: a popup covering the sale on arrival loses shoppers. The card opens from the banner
  // button or the floating pill, which is visible from the first paint.
  if (SID) root.classList.add('is-ready');
  if (pill) pill.hidden = false;
})();
